import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { ICompanyBase } from '@/types'
import { getUniqueReceivedInvestments } from '@/utils'
import { ReceivedInvestmentTooltip } from '@components-v2/molecules/ReceivedInvestmentTooltip'
import styles from './index.module.scss'

type Props = {
  company: ICompanyBase
}

export const CompanyCardWithJobHeaderContentLabel: FC<Props> = ({ company }) => {
  const { t } = useTranslation('jobs')

  return (
    <>
      {company?.receivedInvestments.length > 0 && (
        <div className={styles.investorGroup}>
          {t('投資家：')}
          {getUniqueReceivedInvestments(company.receivedInvestments)
            .slice(0, 5)
            .map((receivedInvestment) => {
              return (
                <div key={receivedInvestment.id} className={styles.investor}>
                  <ReceivedInvestmentTooltip receivedInvestment={receivedInvestment} />
                </div>
              )
            })}
        </div>
      )}
      <p className={styles.companySize}>
        {t('従業員数：')}
        {t(`${company.companySize}`)}
      </p>
    </>
  )
}
